<div class="brand-logos">
  @for (brandLogo of brandLogos; track brandLogo.url) {
    <img [alt]="brandLogo.title" [ngSrc]="basePath + brandLogo.url" height="19" width="93" />
  }
</div>
